import React, { Suspense } from "react";
import { userRoutes, authRoutes, adminRoutes, noLoginRoutes } from "./allRoutes";
import { Route, Routes } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import AdminGuard from "./AdminGuard";

/* Layout */
const CommonLayout = React.lazy(() => import('../Layout/CommonLayout/index'))
const AuthLayout = React.lazy(() => import('../Layout/AuthLayout'))



const Loader = () => {
  return (
    <div id="preloader">
      <div id="status">
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </div>
  );
};

const Index = () => {
  return (
    <React.Fragment>
      <Suspense fallback={<Loader />}>
        <Routes>
          {authRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<AuthLayout>{route.component}</AuthLayout>}
              key={`auth-${idx}`}
            />
          ))}

          {userRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthGuard>
                  <CommonLayout>{route.component}</CommonLayout>
                </AuthGuard>
              }
              key={`user-${idx}`}
            />
          ))}

          {noLoginRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<CommonLayout>{route.component}</CommonLayout>}
              key={`no-login-${idx}`}
            />
          ))}

          {adminRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AdminGuard requiredRole={1}> 
                  <CommonLayout>{route.component}</CommonLayout>
                </AdminGuard>
              }
              key={`admin-${idx}`}
            />
          ))}
        </Routes>
      </Suspense>
    </React.Fragment>
  );
};

export default Index;
